import styled from '@emotion/styled'

export const StepHeader = styled.div`
  color: black;
  font-size: 18px;
`
